export const getStatusTranslation = ({
  isEmpty,
  isExpired,
  isBlocking,
  canDisplayReservationPreview,
  hasUpcomingReservation,
}: {
  isEmpty: boolean;
  isExpired: boolean;
  isBlocking: boolean;
  canDisplayReservationPreview: boolean;
  hasUpcomingReservation: boolean;
}): string => {
  if (hasUpcomingReservation) {
    return 'Page.StorageUnitList.Table.Status.Reserved';
  }

  if (isEmpty) return 'Page.StorageUnitList.Table.Status.Empty';

  if (!canDisplayReservationPreview)
    return 'Page.StorageUnitList.Table.Status.Occupied';

  if (isExpired) return 'Page.StorageUnitList.Table.Status.Expired';
  if (isBlocking) return 'Page.StorageUnitList.Table.Status.Blocking';

  return 'Page.StorageUnitList.Table.Status.Occupied';
};
